import { render } from "./default-empty-message.vue?vue&type=template&id=1a2f69f8&ts=true"
import script from "./default-empty-message.ts?vue&type=script&lang=ts&external"
export * from "./default-empty-message.ts?vue&type=script&lang=ts&external"

import "./default-empty-message.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__